import React from "react";
import PropTypes from "prop-types";
import { useAdminAuth } from "admin/AuthContext";
import AdminNav from "admin/AdminNav";
import logo from "../assets/images/logo.png";

export default function AdminLayout({ children }) {
  const { logout, usingDemoAuth } = useAdminAuth();

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-20 border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
          <div className="flex items-center gap-3">
            <img src={logo} alt="" className="h-9 w-9 rounded-lg" />
            <div>
              <p className="font-display text-lg font-semibold leading-none text-maroon-800">
                VR Food Products
              </p>
              <p className="text-xs font-medium uppercase tracking-wider text-slate-400">
                Admin Dashboard
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            {usingDemoAuth && (
              <span className="hidden rounded-full bg-gold-100 px-3 py-1 text-xs font-semibold text-gold-800 sm:inline">
                Demo mode
              </span>
            )}
            <a
              href="/"
              className="hidden text-sm font-medium text-slate-500 hover:text-maroon-700 sm:inline"
            >
              View site
            </a>
            <button
              type="button"
              onClick={logout}
              className="rounded-lg border border-slate-200 px-3 py-1.5 text-sm font-medium text-slate-600 transition-colors hover:border-maroon-200 hover:bg-maroon-50 hover:text-maroon-700"
            >
              Log out
            </button>
          </div>
        </div>
      </header>
      <AdminNav />
      <main className="mx-auto max-w-6xl px-4 py-8 sm:px-6">{children}</main>
    </div>
  );
}

AdminLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
